





































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { SituacaoClinicaDTO, SituacaoClinicaParm } from '@/interfaces/clinic-situations';
import * as service from '@/services/clinic-situations';
import { PDF_MIME_TYPES } from '@/settings/consts/file-upload';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import UiInputFile from '../UI/input-file.vue';
import ListMessages from '../UI/list-messages.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiInputFile,
  },
})
export default class ClinicSituationForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: number;
  @Prop()
  public open: boolean;

  private loading: boolean = false;
  private error: boolean = false;

  public dto: SituacaoClinicaDTO = new SituacaoClinicaDTO();
  public parm: SituacaoClinicaParm = new SituacaoClinicaParm();
  pdf: any = null;
  private validTypes: string[] = PDF_MIME_TYPES;

  public form: any = {
    valid: false,
    rules: {
      nome: [(v) => !!v || 'Informe o Nome'],
      ativo: [(v) => v != null || 'Informe o Status'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  @Watch('open')
  public watchOpen(): void {
    setTimeout(() => {
      if (this.open) {
        this.init();
      }
    }, 300);
  }

  public init(): void {
    if (!this.id || this.loading) {
      return;
    }
    this.loading = true;
    this.error = false;
    this.addSubsc(
      service.getClinicSituation(this.id).subscribe(
        (result) => {
          this.dto = result;
          this.loading = false;
        },
        (error) => {
          this.error = true;
          this.loading = false;
        },
      ),
    );
  }

  public saveItem(): void {
    this.$refs.form.validate();

    if (!this.form.valid) {
      return;
    }

    this.loader.start('Salvando ...');
    let parm = this.parm;
    parm.id = this.dto.id;
    parm.nome = this.dto.nome;
    parm.descricao = this.dto.descricao;
    parm.ativo = this.dto.ativo;
    this.addSubsc(
      service.saveClinicSituation(parm, this.pdf).subscribe(
        (result) => {
          this.resetForm();
          this.loader.stop();
          this.toast.show('Situação Clínica salva com sucesso', 'success');
          this.$emit('save');
        },
        (error) => {
          this.loader.stop();
          this.showToastApiError(error);
        },
      ),
    );
  }

  public resetForm(): void {
    this.dto = new SituacaoClinicaDTO();
    this.parm = new SituacaoClinicaParm();
    this.$refs.form.resetValidation();
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public closeForm(): void {
    this.dialog.show(
      'error',
      'Sair sem salvar',
      'Deseja sair sem salvar as alterações?',
      'Cancelar',
      '',
      'Sair',
      this.closeAction,
    );
  }

  onDeletePdf() {
    this.parm.pdfExcluido = true;
  }
}
